(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cocomo-99-campaign"] && !Shopify.designMode) return;
  try {
    


(() => {
  const init = (root) => {
    if (root.dataset.c99Ready) return;
    root.dataset.c99Ready = 'true';
    const state = root.querySelector('[data-c99-event-state]');
    const update = () => {
      const now = Date.now();
      const start = Date.parse('2026-09-09T00:00:00+08:00');
      const end = Date.parse('2026-09-09T23:59:00+08:00');
      if (state) state.textContent = now < start ? state.dataset.before : now < end ? state.dataset.active : state.dataset.after;
      root.classList.toggle('c99-ended', now >= end);
    };
    update();
    const hero = root.querySelector('.c99-hero');
    const sticky = root.querySelector('.c99-sticky');
    if (hero && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!root.isConnected) { observer.disconnect(); return; }
        const shown = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
        sticky.classList.toggle('is-visible', shown);
        sticky.inert = !shown;
      });
      sticky.inert = true;
      observer.observe(hero);
    } else if (sticky) sticky.classList.add('is-visible');
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-c99-target]');
      if (!link) return;
      const destination = root.querySelector(link.dataset.c99Target);
      if (!destination) return;
      event.preventDefault();
      event.stopPropagation();
      const inset = parseFloat(getComputedStyle(destination).scrollMarginTop) || 140;
      window.scrollTo({top: window.scrollY + destination.getBoundingClientRect().top - inset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      if (destination.hasAttribute('tabindex')) destination.focus({preventScroll:true});
    });
    document.addEventListener('visibilitychange', update);
    const timer = setInterval(() => {
      if (!root.isConnected) {clearInterval(timer);document.removeEventListener('visibilitychange', update);return;}
      update();
    }, 30000);
  };
  document.querySelectorAll('[data-c99-root]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-c99-root]').forEach(init));
})();


(function(){if(!window.MutationObserver)return;var scope='[data-c99-root]';var wrapperSelector=".CocomoCollectionCard .CocomoCollectionCard__Flair";function withLineBreaks(value){return value.replace(/,[ \t\u00a0]*(?:\r?\n)?/g,function(match,index,whole){if(/\d/.test(whole[index-1]||"")&&/\d/.test(whole[index+1]||""))return match;return"\n"})}function offerKind(value){if(/\bclearance\b/i.test(value))return"clearance";if(/\bbest[\s-]*(?:seller|selling)s?\b/i.test(value))return"bestseller";if(/\b(?:new[\s-]+(?:arrival|launch|in)|just[\s-]+(?:arrived|launched))s?\b/i.test(value))return"new";return"offer"}document.querySelectorAll(scope).forEach(function(root){if(root.hasAttribute("data-cocomo-collection-badges-ready"))return;root.setAttribute("data-cocomo-collection-badges-ready","");var passes=new WeakMap;var active=true;function format(wrapper){if(!root.contains(wrapper)||(passes.get(wrapper)||0)>=8)return;var host=wrapper.querySelector("[data-flair-product-badge]");if(!host)return;var textUpdates=[];var chipUpdates=[];var kindUpdates=[];host.querySelectorAll(".flair-badge > div").forEach(function(label){var kind=offerKind(label.textContent);if(label.getAttribute("data-cocomo-offer-kind")!==kind)kindUpdates.push([label,kind]);var children=Array.from(label.children);var plainText=Array.from(label.childNodes).every(function(node){return node.nodeType===3});var ownChips=label.classList.contains("CocomoCollectionOffers")&&children.every(function(child){return child.classList.contains("CocomoCollectionOffer")&&child.childElementCount===0});if(plainText||ownChips){var parts=withLineBreaks(label.textContent).split(/\r?\n/).map(function(part){return part.trim()}).filter(Boolean);if(!parts.length)return;var same=ownChips&&children.length===parts.length&&label.textContent===parts.join("\n")&&children.every(function(child,index){return child.textContent===parts[index]&&child.getAttribute("data-offer-kind")===offerKind(parts[index])});if(!same)chipUpdates.push([label,parts]);return}var walker=document.createTreeWalker(label,NodeFilter.SHOW_TEXT,{acceptNode:function(node){return node.parentElement.closest("style,script,noscript,textarea,svg")?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT}});var node;while(node=walker.nextNode()){var next=withLineBreaks(node.data);if(next!==node.data)textUpdates.push([node,next])}});if(!textUpdates.length&&!chipUpdates.length&&!kindUpdates.length)return;passes.set(wrapper,(passes.get(wrapper)||0)+1);textUpdates.forEach(function(update){update[0].data=update[1]});kindUpdates.forEach(function(update){update[0].setAttribute("data-cocomo-offer-kind",update[1])});chipUpdates.forEach(function(update){var fragment=document.createDocumentFragment();update[1].forEach(function(part,index){if(index)fragment.appendChild(document.createTextNode("\n"));var chip=document.createElement("span");chip.className="CocomoCollectionOffer";chip.setAttribute("data-offer-kind",offerKind(part));chip.textContent=part;fragment.appendChild(chip)});update[0].replaceChildren(fragment);update[0].classList.add("CocomoCollectionOffers")})}function collect(node,dirty){if(node.nodeType!==1)return;if(node.matches(wrapperSelector))dirty.add(node);node.querySelectorAll(wrapperSelector).forEach(function(wrapper){dirty.add(wrapper)})}function connect(){if(active&&root.isConnected)observer.observe(root,{childList:true,characterData:true,subtree:true})}var observer=new MutationObserver(function(records){if(!active)return;var dirty=new Set;records.forEach(function(record){var target=record.target.nodeType===1?record.target:record.target.parentElement;var wrapper=target&&target.closest(wrapperSelector);if(wrapper){if((passes.get(wrapper)||0)<8)dirty.add(wrapper)}else{record.addedNodes.forEach(function(node){collect(node,dirty)})}});if(!dirty.size)return;observer.disconnect();try{dirty.forEach(format)}finally{connect()}});root.querySelectorAll(wrapperSelector).forEach(format);connect();window.addEventListener("pagehide",function(){active=false;observer.disconnect()});window.addEventListener("pageshow",function(event){if(!event.persisted)return;active=true;root.querySelectorAll(wrapperSelector).forEach(format);connect()})})})();(function(){if(!window.requestAnimationFrame||!window.MutationObserver)return;document.querySelectorAll('[data-c99-root]').forEach(function(root){if(root.hasAttribute("data-cocomo-collection-rows-ready"))return;root.setAttribute("data-cocomo-collection-rows-ready","");var frame=0;var active=true;var width=0;var mobile=window.matchMedia("(max-width: 1007px)");function syncRows(){frame=0;if(!active||!root.isConnected)return;var rows=[];root.querySelectorAll(".CocomoCollectionCard").forEach(function(card){var box=card.getBoundingClientRect();if(!box.width||!box.height)return;var top=card.querySelector(".CocomoCollectionCard__TopBadges");var flair=card.querySelector(".CocomoCollectionCard__Flair");var host=flair&&flair.querySelector("[data-flair-product-badge]");var height=0;if(top&&mobile.matches){Array.from(top.children).forEach(function(badge){height=Math.max(height,badge.getBoundingClientRect().height)})}var item={top:top,flair:flair,topHeight:Math.ceil(height),flairHeight:host?Math.ceil(host.getBoundingClientRect().height):0};var row=rows.find(function(candidate){return Math.abs(candidate.y-box.top)<2});if(!row){row={y:box.top,topHeight:0,flairHeight:0,items:[]};rows.push(row)}row.items.push(item);row.topHeight=Math.max(row.topHeight,item.topHeight);row.flairHeight=Math.max(row.flairHeight,item.flairHeight)});rows.forEach(function(row){row.items.forEach(function(item){[[item.top,mobile.matches?row.topHeight:0],[item.flair,row.flairHeight]].forEach(function(entry){if(!entry[0])return;var next=entry[1]?entry[1]+"px":"";if(entry[0].style.minHeight!==next)entry[0].style.minHeight=next});if(item.flair){var margin=row.flairHeight?"8px":"0px";if(item.flair.style.marginBottom!==margin)item.flair.style.marginBottom=margin}})})}function schedule(){if(active&&!frame)frame=window.requestAnimationFrame(syncRows)}var observer=new MutationObserver(function(records){var relevant=records.some(function(record){var target=record.target.nodeType===1?record.target:record.target.parentElement;if(!target)return false;if(record.type==="attributes"&&record.attributeName==="style"&&target.matches(".CocomoCollectionCard__TopBadges,.CocomoCollectionCard__Flair"))return false;if(target.closest(".CocomoCollectionCard__Flair,.CocomoCollectionCard__TopBadges"))return true;if(record.type==="attributes")return target.matches(".Grid__Cell,.ProductList,.CocomoCollectionCard");return Array.from(record.addedNodes).some(function(node){return node.nodeType===1&&(node.matches(".CocomoCollectionCard")||node.querySelector(".CocomoCollectionCard"))})||Array.from(record.removedNodes).some(function(node){return node.nodeType===1&&(node.matches(".CocomoCollectionCard")||node.querySelector(".CocomoCollectionCard"))})});if(relevant)schedule()});var resize=window.ResizeObserver?new ResizeObserver(function(entries){var next=entries[0].contentRect.width;if(next!==width){width=next;schedule()}}):null;function connect(){observer.observe(root,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:["class","style","hidden"]});if(resize)resize.observe(root)}connect();schedule();window.addEventListener("resize",schedule,{passive:true});if(document.fonts){document.fonts.ready.then(schedule);document.fonts.addEventListener("loadingdone",schedule)}window.addEventListener("pagehide",function(){active=false;observer.disconnect();if(resize)resize.disconnect();if(frame)window.cancelAnimationFrame(frame);frame=0});window.addEventListener("pageshow",function(event){if(!event.persisted)return;active=true;connect();schedule()})})})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocomo-brands-directory"]) return;
  try {
    
(function () {
  'use strict';

  function normalize(value) {
    return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function initialize(root) {
    if (root.__cbpCleanup) return;
    var search = root.querySelector('[data-cbp-search]');
    var clear = root.querySelector('[data-cbp-clear]');
    var status = root.querySelector('[data-cbp-status]');
    var empty = root.querySelector('[data-cbp-empty]');
    var form = root.querySelector('[data-cbp-form]');
    if (!search || !clear || !status || !empty || !form) return;

    var letters = Array.from(root.querySelectorAll('[data-cbp-letter]'));
    var groups = Array.from(root.querySelectorAll('[data-cbp-group]')).map(function (element) {
      return {
        element: element,
        letter: element.getAttribute('data-cbp-group'),
        brands: Array.from(element.querySelectorAll('[data-cbp-brand]')).map(function (brand) {
          var link = brand.querySelector('a');
          return {element: brand, name: normalize(link ? link.textContent : brand.textContent)};
        })
      };
    });
    var selected = '';
    var section = root.closest('.shopify-section') || root;
    var allLabel = status.getAttribute('data-all-label') || status.textContent;
    var filterLabel = status.getAttribute('data-filter-label') || '__COUNT__';
    var oneLabel = status.getAttribute('data-filter-one-label') || filterLabel;

    function render() {
      var query = normalize(search.value);
      var count = 0;
      groups.forEach(function (group) {
        var groupCount = 0;
        group.brands.forEach(function (brand) {
          var matches = (!selected || selected === group.letter) && (!query || brand.name.indexOf(query) !== -1);
          if (brand.element.hidden === matches) brand.element.hidden = !matches;
          if (matches) groupCount++;
        });
        if (group.element.hidden === (groupCount > 0)) group.element.hidden = !groupCount;
        count += groupCount;
      });
      letters.forEach(function (letter) {
        if (letter.getAttribute('data-cbp-letter') === selected && letter.getAttribute('aria-disabled') !== 'true') {
          letter.setAttribute('aria-current', 'true');
        } else {
          letter.removeAttribute('aria-current');
        }
      });
      clear.hidden = !search.value;
      empty.hidden = count !== 0;
      root.dataset.cbpFiltered = String(Boolean(query || selected));
      status.textContent = selected || query ? (count === 1 ? oneLabel : filterLabel).replace(/__COUNT__/g, String(count)) : allLabel;
    }

    function onInput() {
      selected = '';
      render();
    }

    function onSubmit(event) {
      event.preventDefault();
      onInput();
    }

    function onClick(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = event.target.closest ? event.target.closest('[data-cbp-letter], [data-cbp-clear]') : null;
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      if (target.hasAttribute('data-cbp-clear')) {
        selected = '';
        search.value = '';
        render();
        search.focus();
        return;
      }
      if (target.getAttribute('aria-disabled') === 'true') return;
      var next = target.getAttribute('data-cbp-letter');
      if (next && !groups.some(function (group) { return group.letter === next; })) return;
      selected = next;
      search.value = '';
      render();
    }

    function cleanup() {
      search.removeEventListener('input', onInput);
      form.removeEventListener('submit', onSubmit);
      root.removeEventListener('click', onClick);
      section.removeEventListener('shopify:section:unload', onUnload);
      delete root.__cbpCleanup;
      delete root.dataset.cbpReady;
      selected = '';
      search.value = '';
      render();
      delete root.dataset.cbpFiltered;
    }

    function onUnload(event) {
      if (event.target === section || event.target === root || (event.target.contains && event.target.contains(root))) cleanup();
    }

    root.__cbpCleanup = cleanup;
    root.dataset.cbpReady = 'true';
    search.addEventListener('input', onInput);
    form.addEventListener('submit', onSubmit);
    root.addEventListener('click', onClick);
    section.addEventListener('shopify:section:unload', onUnload);
    render();
  }

  function start() {
    document.querySelectorAll('[data-cbp-directory]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();


  } catch(e) { console.error(e); }
})();
})();
